import { createLucideIcon } from 'lucide-react';
export const BanIcon = createLucideIcon('ban-icon', [
  [
    'path',
    {
      d: 'M -4 34 C-4 31.955 -3.259 30.095 -2.031 28.656',
      key: 'u3cft7',
    },
  ],
  [
    'path',
    {
      d: 'M -4 37 L -3.219 45.344',
      key: 'i616r4',
    },
  ],
  [
    'path',
    {
      d: 'M -6.5 34 C-5.079 32.837 4.727 34.398 -1.273 32.148',
      key: '1la4b9',
    },
  ],
  [
    'path',
    {
      d: 'M 0.5 33.5 L -6.5 52.25',
      key: '1amtva',
    },
  ],
  [
    'path',
    {
      d: 'M 2 36.5 C-2.564 36.5 -6.25 32.814 -6.25 28.25',
      key: '21cdpt',
    },
  ],
  [
    'path',
    {
      d: 'M 25 48 L 13.492 36.258',
      key: 'oah6s7',
    },
  ],
  [
    'path',
    {
      d: 'M 27.5 38.5 C27.5 40.545 26.759 42.405 25.531 43.844',
      key: '13b85r',
    },
  ],
  [
    'path',
    {
      d: 'M 31 36.5 C29.579 37.664 36.773 57.602 25.773 38.352',
      key: '1e2vag',
    },
  ],
  [
    'path',
    {
      d: 'M 38.5 40.5 C43.064 40.5 46.75 44.186 46.75 48.75',
      key: 'iwegmm',
    },
  ],
  [
    'path',
    {
      d: 'M 6 6 L 18.5 18.5',
      key: 'ts8qxn',
    },
  ],
  [
    'path',
    {
      d: 'M12 2.25C6.624 2.25 2.25 6.624 2.25 12C2.25 17.376 6.624 21.75 12 21.75C17.376 21.75 21.75 17.376 21.75 12C21.75 6.624 17.376 2.25 12 2.25Z',
      key: '1hlyf9',
    },
  ],
]);
